
import React from 'react';
import { formatCurrency } from '@/utils/formatters';
import { Badge } from '@/components/ui/badge';
import { Transaction } from '@/types/transaction';

interface TransactionNetAmountProps {
  transaction: Transaction;
}

const TransactionNetAmount: React.FC<TransactionNetAmountProps> = ({ transaction }) => {
  return (
    <div className=" rounded-lg p-4 bg-[#F2F2F2]">
     <div className='flex items-start justify-between'> <h3 className="text-sm font-medium text-muted-foreground mb-1">Amount</h3>
      <Badge 
          variant={transaction.status === 'succeeded' ? 'success' : 'outline'} 
          className="ml-2 capitalize"
        >
          {transaction.status.replace('_', ' ')}
        </Badge></div>
      <div className="flex items-center">
        <p className="text-2xl font-semibold">
          {(() => {
            const amountInDollars = transaction.gross_amount_cents 
              ? transaction.gross_amount_cents / 100
              : transaction.net_amount_cents 
                ? transaction.net_amount_cents / 100
                : transaction.amount 
                  ? (typeof transaction.amount === 'number' && transaction.amount > 1000 ? transaction.amount / 100 : transaction.amount)
                  : 0;
            return formatCurrency(amountInDollars);
          })()}
        </p>
        
      </div>
      <p className="text-sm text-muted-foreground mt-1">
        {formatDate(
          transaction.created 
            ? new Date(transaction.created * 1000) 
            : transaction.created_at
              ? new Date(isNaN(Number(transaction.created_at)) ? transaction.created_at : Number(transaction.created_at) * 1000)
              : new Date()
        )}
      </p>
    </div>
  );
};

const formatDate = (date: Date) => {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  }).format(date);
};

export default TransactionNetAmount;